import React, { useEffect } from 'react';
import { useAnalytics } from '../../../../../app/data/AnalyticsProvider';
import {
  SyncStatusCardWrapper,
  StatusStep,
  StepIconWrapper,
  StepIcon,
  StepContent,
  StepTitle,
  StepDescription,
  EntityName,
  EmptyCircleStep
} from './AssetVipSyncingTab.styles';

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
  <path d="M8.67357 0.735917L4.0039 5.40825L1.66655 3.07161" stroke="white" strokeWidth="2"/>
</svg>
);

const CrownIcon = ({bgColor = 'white'}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="12" fill={bgColor}/>
<path d="M12 6.61865L14 10.9999L17 8.40437V14.1187H7V8.40437L10 10.9999L12 6.61865Z" fill="#DEB482"/>
<path fillRule="evenodd" clipRule="evenodd" d="M16.5 16.3809H7.5V15.1809H16.5V16.3809Z" fill="#DEB482"/>
<path d="M7.21041 21.249C7.06199 21.5356 7.17348 21.8898 7.46757 22.0228C9.86274 23.1061 12.574 23.2982 15.1079 22.5518C17.8293 21.7503 20.1357 19.9284 21.5455 17.4666C22.9553 15.0048 23.3595 12.0935 22.6737 9.34072C22.0351 6.77748 20.4974 4.53627 18.351 3.01862C18.0874 2.83227 17.7255 2.91537 17.5534 3.18843C17.3813 3.46149 17.4644 3.82099 17.7268 4.00899C19.6186 5.3647 20.9738 7.35261 21.5395 9.62329C22.1525 12.0835 21.7912 14.6855 20.5312 16.8857C19.2712 19.0859 17.2098 20.7142 14.7777 21.4306C12.5329 22.0918 10.1326 21.9289 8.00587 20.9832C7.71094 20.8521 7.35884 20.9624 7.21041 21.249Z" fill="#DEB482"/>
</svg>
);


export const VipSyncStatusCard = ({ institutionName = '',  is3rdParty = false , maxWidth = '100%' , showAsCard = false , showAsToolTip = false, isAfterCreationModal = false  }) => {
  const { mixpanelTrack } = useAnalytics();

  useEffect(() => {
    mixpanelTrack('VIP Sync Status Viewed', {
      institution_name: institutionName,
      is_third_party: is3rdParty,
      status: 'pending',
      url: window.location.href
    });
  }, [mixpanelTrack, institutionName, is3rdParty]);
  
  return (
    <SyncStatusCardWrapper maxWidth={maxWidth} showAsCard={showAsCard} >
      <StatusStep lineColor={'#DEB482'}>
        <StepIconWrapper>
          <StepIcon completed={true}>
            <CheckIcon />
          </StepIcon>
        </StepIconWrapper>
        <StepContent>
          <StepTitle isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>{isAfterCreationModal ? '1. ' : ''}{is3rdParty ? `Access Requested` : `Access Granted`} </StepTitle>
          <StepDescription isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>{is3rdParty ? (isAfterCreationModal ? `A read-only access request has been sent to ${institutionName}.` : `Your authorization has been sent.`) : `You’ve confirmed read-only access to your portal.`}</StepDescription>
        </StepContent>
      </StatusStep>

      <StatusStep>
        <StepIconWrapper>
        <CrownIcon bgColor={showAsToolTip ? '#000' : '#fff'} />
            
        </StepIconWrapper>
        <StepContent>
          <StepTitle isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>{isAfterCreationModal ? '2. ' : ''}Pending</StepTitle>
          <StepDescription isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>
          {is3rdParty ? ( isAfterCreationModal ? <>{institutionName} is reviewing the request. Approval times may vary.</> : 
          <>
            Waiting for <EntityName>{institutionName}</EntityName> to approve 
            read-only access. Processing times may vary.
            </> ) : `We’re verifying access to your portal. Please ensure permission has been granted so we can proceed.`}
          </StepDescription>
        </StepContent>
      </StatusStep>

      <StatusStep>
        <StepIconWrapper>
         
             <EmptyCircleStep bgColor={showAsToolTip ? '#000' : '#fff'} />
      
        </StepIconWrapper>
        <StepContent>
          <StepTitle isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>{isAfterCreationModal ? '3. ' : ''}Initial Sync</StepTitle>
          <StepDescription isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>
          {is3rdParty ? ( isAfterCreationModal ? `Once access is granted, we’ll pull your latest balances and cash flow.` : `Once verified, we’ll pull your latest balances and cash flow updates.` ) : `Once verified, we’ll pull your latest balances and cash flow updates.`}
          </StepDescription>
        </StepContent>
      </StatusStep>

      <StatusStep>
        <StepIconWrapper>
        <EmptyCircleStep  bgColor={showAsToolTip ? '#000' : '#fff'}/>
        </StepIconWrapper>
        <StepContent>
          <StepTitle isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>{isAfterCreationModal ? '4. ' : ''}Ongoing Updates</StepTitle>
          <StepDescription isAfterCreationModal={isAfterCreationModal} isToolTip={showAsToolTip}>
            {is3rdParty ? ( isAfterCreationModal ? <>
              Your data will update based on {institutionName}’s reporting schedule.
            </> : <>
            Data refreshes based on <EntityName>{institutionName}'s</EntityName> reporting schedule.
            </>) : `Your data refreshes based on your portal’s reporting schedule.`}
          </StepDescription>
        </StepContent>
      </StatusStep>
    </SyncStatusCardWrapper>
  );
};